<template>
	<el-dialog :before-close="onClose" :visible.sync="isShow" center destroy-on-close top="21vh" width="45%">
		<div>
			<div v-if="interType !== 1">
				<div class="header_title u-m-b-20">{{ getTitle }}</div>
				<span class="u-font-weight-bold u-font-16">温馨提示：您即将进入投保流程</span>
				<div v-if="isFgk(insureType) || isFgkDianti(insureType)" class="u-m-t-5" style="line-height: 24px">
					请仔细阅读
					<span class="red-bold">保险条款、客户告知</span>
					等内容，为保障您的权益，我们将会安全记录您的操作。
					<br />
					基于提供保险服务、提高理赔服务质量的需要，您授权：上海太平洋保险的合作机构“
					<span class="red-bold">IE保</span>
					”在承保前或承保后以多种方式核实投保信息的真实性、调查获取被保险人与保险有关的相关信息，如上海太平洋保险经前述核查发现您存在未如实告知情况的，上海太平洋保险将依法解除保险合同；上海太平洋保险及上海太平洋保险的合作机构“
					<span class="red-bold">IE保</span>
					”可对您的理赔信息进行合理获取及使用。为确保信息安全，上海太平洋及合作机构“
					<span class="red-bold">IE保</span>
					”应采取有效措施，并承担保密义务。
				</div>
				<div v-else class="u-m-t-5">
					请仔细阅读
					<span class="red-bold">保险条款、客户告知</span>
					等内容，为保障您的权益，我们将会安全记录您的操作
				</div>
			</div>
			<div v-else>
				<div class="html-content" v-html="htmlContent"></div>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="onClose">不同意</el-button>
			<el-button type="primary" @click="onNext">已知悉并同意</el-button>
		</span>
	</el-dialog>
</template>

<script>
import {insureMap} from '@/const/crud/insurance/product'
import {isFgk, isFgkDianti} from '@/util/productUtil'

export default {
	name: 'insureBeginNotice',
	props: {
		interType: {
			type: String | Number,
			required: true,
		},
		insureType: {
			type: String | Number,
			required: true,
		},
		productId: {
			type: String | Number,
			required: true,
		},
	},
	data() {
		return {
			isShow: false,
			htmlContent: '',
		}
	},
	watch: {},
	mounted() {},
	computed: {
		getTitle() {
			if (this.interType === 1) {
				return ''
			}
			//通过险种获取保险公司
			let data = insureMap.get(parseInt(this.insureType))
			if (!this.validatenull(data)) {
				return `本产品由【${data.insureName}】承保`
			}
			return ''
		},
	},
	created() {},
	methods: {
		//展示弹窗
		showHint(htmlContent = '') {
			this.isShow = true
			this.htmlContent = htmlContent
		},
		onNext() {
			this.isShow = false
			this.$emit('onNext')
		},
		onClose() {
			this.isShow = false
		},
		isFgk,
		isFgkDianti,
	},
}
</script>
<style lang="scss" scoped>
.header_title {
	display: flex;
	font-weight: bold;
	font-size: 18px;
	justify-content: center;
}

.container::-webkit-scrollbar {
	display: none;
}

span.red {
	color: Red;
	font-weight: bold;
}

.blue {
	color: DodgerBlue !important;
	font-weight: bold;
}

::v-deep .html-content p {
	margin: 3px !important;
}

::v-deep .el-dialog__body {
	padding: 0 25px 25px;
}
</style>
